/* eslint-disable @typescript-eslint/indent */
import { getBFFApiClient } from '@acp/feature/auth';
import {
    APIResponse,
    BookableService,
    BookableServiceV2,
    Contact,
    OasBookingTime,
    OasResult,
    PriorityLevel,
} from '@acp/shared';
import HttpStatusCodes from 'http-status-codes';

async function getBookableServicesByPropertyId(propertyId: number) {
    const response = await getBFFApiClient().get<APIResponse<BookableService[]>>(`/v1/property/${propertyId}/services/bookable`);

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error('Failed to get oas results');
    }

    return response.data.data;
}

async function getBookableServicesByPropertyIdV2(propertyId: number) {
    const response = await getBFFApiClient().get<APIResponse<BookableServiceV2[]>>(`/v2/property/${propertyId}/services/bookable`);

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error('Failed to get oas results V2');
    }

    return response.data.data;
}

async function getAvailableOasTimes(
    propertyId: number,
    service: string
) {
    const response = await getBFFApiClient().get<APIResponse<OasBookingTime[]>>(
        `/v1/property/${propertyId}/booking/availability?service=${service}`
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error('Failed to get oas results');
    }

    return response.data.data;
}

async function submitBookingData({
    propertyId,
    bookingTypes,
    contacts,
    oasResult,
}: {
    propertyId: number;
    bookingTypes: string;
    contacts: Contact[];
    oasResult: OasResult;
}) {
    const response = await getBFFApiClient().post<APIResponse<null>>(`/v1/property/${propertyId}/booking`, {
        propertyId,
        bookingTypes,
        contacts,
        oasResult,
    });

    if (!response.data.success) {
        throw new Error(response.data.error);
    }

    if (response.status !== HttpStatusCodes.OK) {
        throw new Error('Failed to submit booking');
    }

    return response.data.data;
}

async function getPriorityLevels(serviceSuffix: string, isInternal: boolean | null) {
    const response = await getBFFApiClient().get<APIResponse<PriorityLevel[]>>(
        '/v1/priority-level',
        {
            params: {
                serviceSuffix,
                isInternal,
            },
        }
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get priority levels: ${response.data.error}`);
    }

    return response.data.data;
}

export {
    getBookableServicesByPropertyId,
    getBookableServicesByPropertyIdV2,
    getAvailableOasTimes,
    submitBookingData,
    getPriorityLevels,
};
